import React from "react";
import styles from "./SectionHeadliner.module.scss";

type TSectionHeadliner = {
	topLeft: React.ReactNode;
	topRight: React.ReactNode;
	top?: React.ReactNode;
	bottom: React.ReactNode;
	optionalButtons?: React.ReactNode;
};

const SectionHeadliner: React.FC<TSectionHeadliner> = ({ bottom, topLeft, optionalButtons, topRight, top }) => {
	return (
		<div className={styles.eventHeadline}>
			{top ? top : null}
			<div className={styles.top}>
				<div className={styles.topLeft}>{topLeft}</div>
				<div className={styles.topRight}>{topRight}</div>
			</div>
			{optionalButtons && <div className={styles.optionalButtons}>{optionalButtons}</div>}
			<div className={styles.bottom}>{bottom}</div>
		</div>
	);
};

export default SectionHeadliner;
